import React, { useEffect, useState, useRef, useFormContext } from "react";
import { useNavigate, useLocation } from "react-router-dom"; // Import required hooks from react-router-dom
import { CognitoAuth } from "../Utils/cognito-auth";
import { useAuth } from "../Utils/AuthContext";
import $ from "jquery";
import "bootstrap/dist/css/bootstrap.min.css";
import "./LogIn.css";
import {
  Row,
  Col,
  Form,
  Button,
  FormControl,
  Container,
} from "react-bootstrap";

function LogIn() {
  const { name, email } = useAuth();
  const navigate = useNavigate(); // Hook to navigate programmatically
  const location = useLocation(); // Hook to access the current location

  const emailInputSigninRef = useRef(null);
  const emailInputSigninErrorRef = useRef(null);
  const emailInputRegisterErrorRef = useRef(null);

  const signInButtonRef = useRef(null);
  const registerButtonRef = useRef(null);
  const verifyButtonRef = useRef(null);
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const forgotPasswordButtonRef = useRef(null);

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isRegistered, setIsRegistered] = useState(false);
  const [validatedSignin, setValidatedSignin] = useState(false);
  const [validatedRegister, setValidatedRegister] = useState(false);
  const [errors, setErrors] = useState({});
  const [activeSection, setActiveSection] = useState("signin");
  const {
    handleSignin,
    setPageElements,
    register,
    handleVerify,
  } = CognitoAuth({ setIsRegistered, setValidatedSignin, setValidatedRegister });

  useEffect(() => {
    if (email && name) {
      setIsAuthenticated(true);
    }
  });

  const checkAuthentication = async () => {
    if (isAuthenticated) {
      const fromPage = location.state?.from || '/';
      navigate(fromPage);
    }
  };

  function handleSectionChange(section) {
      setActiveSection(section);
      resetOtherSectionValidation(section);
  }

  function redirectToForgotPasswordPage() {
    navigate("/forgotpassword");
  }

  function resetOtherSectionValidation(currentSection) {
    if (currentSection === "signin") {
        setValidatedRegister(false);
        setErrors({});
    } else if (currentSection === "register") {
        setValidatedSignin(false);
        setErrors({});
    }
  }

  function findFormErrors() {
      const newErrors = {};

      if (activeSection === "signin") {
          const emailSignin = $("#emailInputSignin").val();
          if (!emailPattern.test(emailSignin)) {
              newErrors.emailSignin = "Please enter a valid email address.";
          }
      }

      if (activeSection === "register") {
          const emailRegister = $("#emailInputRegister").val();
          if (!emailPattern.test(emailRegister)) {
              newErrors.emailRegister = "Please enter a valid email address.";
          }
      }

      return newErrors;
  }

  function handleSubmitSignin(event) {
      resetOtherSectionValidation("signin");
      const form = event.currentTarget;

      event.preventDefault();

      if (form.checkValidity() === false) {
          event.stopPropagation();
      }

      const newErrors = findFormErrors();

      if (Object.keys(newErrors).length === 0 && form.checkValidity()) {
          handleSignin(event);
          setValidatedSignin(true);
      } else {
          setErrors(newErrors);
          setValidatedSignin(true);
      }
  }

  function handleRegister(event) {
      resetOtherSectionValidation("register");
      const form = event.currentTarget;

      event.preventDefault();

      if (form.checkValidity() === false) {
          event.stopPropagation();
          setValidatedRegister(true);
          return;
      }
      const newErrors = findFormErrors();
      if (Object.keys(newErrors).length === 0 && form.checkValidity()) {
        setValidatedRegister(true);

        var email = $("#emailInputRegister").val();
        var name = $("#nameInputRegister").val();
        var password = $("#passwordInputRegister").val();
        var password2 = $("#password2InputRegister").val();

        var onSuccess = function registerSuccess(result) {
            var cognitoUser = result.user;
            var confirmation =
                "Registration successful. Please check your email inbox or spam folder for your verification code and verify below.";
            if (confirmation) {
                alert(confirmation);
                var sectionsToHide = [
                    "#signInSection",
                    "#registerSection",
                    "#notAuthenticatedSection",
                ];
                var elementsToEnableAndClear = ["#verifySection"];
                var elementsToDisableAndClear = ["#signInSection", "#registerSection"];
                var sectionsToShow = ["#verifySection", "#verifyRegistrationSection"];
                var errorElementsToClear = [
                    "#emailSigninError",
                    "#emailRegisterError",
                    "#emailVerifyError",
                    "#passwordInputSignin"
                ];
                setIsRegistered(true);
                setPageElements(
                    sectionsToHide,
                    elementsToEnableAndClear,
                    elementsToDisableAndClear,
                    sectionsToShow,
                    errorElementsToClear
                );
            }
        };

        var onFailure = function registerFailure(err) {
            if (err && err.code && err.code.indexOf("UsernameExistsException") !== -1) {
                alert(err.message + ". Please Signin using your existing information.");
            } else if (err && err.message) {
                alert(err.message);
            } else {
                alert("An unknown error occurred during registration.");
            }
            setValidatedRegister(false);

        var sectionsToHide = [
            "#verifySection",
            "#verifyRegistrationSection",
            "#postsSection",
        ];
        var elementsToEnableAndClear = ["#signInSection", "#registerSection"];
        var elementsToDisableAndClear = ["#verifySection"];
        var sectionsToShow = [
            "#signInSection",
            "#registerSection",
            "#notAuthenticatedSection",
        ];
        var errorElementsToClear = [
            "#emailSigninError",
            "#emailRegisterError",
            "#emailVerifyError",
            "#passwordInputSignin"
        ];
        setIsRegistered(false);

        setPageElements(
            sectionsToHide,
            elementsToEnableAndClear,
            elementsToDisableAndClear,
            sectionsToShow,
            errorElementsToClear
        );
    };


        if (password === password2) {
            register(email, name, password, onSuccess, onFailure);
        } else {
            alert("Passwords do not match");
        }
      }
      else {
        setErrors(newErrors);
        setValidatedRegister(true);
    }
  }

  useEffect(() => {
    checkAuthentication();
  }, [isAuthenticated]);

  return (
    <>
      <div className="forum-page">
        {!isAuthenticated && (
          <div id="notAuthenticatedSection">
            <Row style={{ height: "20px" }}></Row>
            <Row>
              <Col lg={6} md={6} sm={12} xs={12}>
                <Row style={{ height: "20px" }}></Row>

                <div
                  className="Auth-form-container   d-flex align-items-center justify-content-center"
                  id="signInSection"
                  style={{ width: "100%" }}
                >
                  <Form
                    noValidate
                    validated={validatedSignin}
                    role="form"
                    id="signinForm"
                    onSubmit={handleSubmitSignin}
                    className="Auth-form"
                  >
                    <div className="Auth-form-content">
                      <h6 className="text-heading Auth-form-title">Sign In</h6>
                      <Form.Group>
                        <Row style={{ padding: "5px" }}>
                          <Col
                            lg={4}
                            md={4}
                            sm={4}
                            xs={4}
                            style={{ marginTop: "10px" }}
                          >
                            <Form.Label>Email Address</Form.Label>
                          </Col>
                          <Col lg={8} md={8} sm={8} xs={8}>
                            <Form.Control
                              type="email"
                              ref={emailInputSigninRef}
                              id="emailInputSignin"
                              placeholder="Email"
                              autoComplete="emailInputSignin"
                              required
                              style={{ width: "90%" }}
                            />
                            <Form.Control.Feedback type="invalid">
                              <span
                                id="emailSigninError"
                                ref={emailInputSigninErrorRef}
                              >
                                {" "}
                                {errors.emailSignin ||
                                  "Please enter a valid email address."}
                              </span>
                            </Form.Control.Feedback>
                          </Col>
                        </Row>
                      </Form.Group>
                      <Form.Group>
                        <Row style={{ padding: "5px" }}>
                          <Col lg={4} md={4} sm={4} xs={4}>
                            <Form.Label>Password</Form.Label>
                          </Col>
                          <Col lg={8} md={8} sm={8} xs={8}>
                            <Form.Control
                              type="password"
                              minLength="6"
                              id="passwordInputSignin"
                              autoComplete="current-password"
                              placeholder="Password"
                              pattern=".*"
                              required
                              style={{ width: "90%" }}
                            ></Form.Control>
                            <Form.Control.Feedback type="invalid">
                              <span>Please enter a valid Password.</span>
                            </Form.Control.Feedback>
                          </Col>
                        </Row>
                      </Form.Group>
                      <div className="d-grid gap-2 mt-3">
                        <Button
                          name="signInButton"
                          ref={signInButtonRef}
                          type="submit"
                          onClick={() => handleSectionChange("signin")}
                          className="btn btn-navy mx-auto"
                          style={{ width: "100%", whiteSpace: "nowrap", backgroundColor: "#4CAF50" }}
                        >
                          Sign In
                        </Button>
                      </div>
                      <div className="d-grid">
                        <Button
                          name="forgotPasswordButton"
                          ref={forgotPasswordButtonRef}
                          type="submit"
                          onClick={() => redirectToForgotPasswordPage()}
                          className="btn btn-navy mx-auto"
                          style={{ width: "100%", whiteSpace: "nowrap", backgroundColor: "#4CAF50" }}
                        >
                          Or Take me to Forgot Password Page
                        </Button>
                      </div>
                    </div>
                  </Form>
                </div>
              </Col>
              <Col lg={6} md={6} sm={12} xs={12}>
                <div
                  className="Auth-form-container   d-flex align-items-center justify-content-center"
                  id="registerSection"
                >
                  <Form
                    noValidate
                    validated={validatedRegister}
                    id="registrationForm"
                    onSubmit={handleRegister}
                    className="Auth-form"
                  >
                    <div className="Auth-form-content">
                      <h6 className="text-heading Auth-form-title">Register</h6>
                      <Form.Group>
                        <Row style={{ padding: "5px" }}>
                          <Col lg={4} md={4} sm={4} xs={4}>
                            <Form.Label>Email Address</Form.Label>
                          </Col>
                          <Col lg={8} md={8} sm={8} xs={8}>
                            <Form.Control
                              type="email"
                              id="emailInputRegister"
                              autoComplete="emailInputRegister"
                              placeholder="Email"
                              required
                              style={{ width: "90%" }}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.emailRegister ||
                                "Please enter a valid email address."}
                            </Form.Control.Feedback>
                          </Col>
                        </Row>
                      </Form.Group>
                      <Form.Group>
                        <Row style={{ padding: "5px" }}>
                          <Col lg={4} md={4} sm={4} xs={4}>
                            <Form.Label>Full Name</Form.Label>
                          </Col>
                          <Col lg={8} md={8} sm={8} xs={8}>
                            <Form.Control
                              type="name"
                              id="nameInputRegister"
                              placeholder="Name"
                              pattern=".*"
                              required
                              style={{ width: "90%" }}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please enter a valid Full Name.
                            </Form.Control.Feedback>
                          </Col>
                        </Row>
                      </Form.Group>
                      <Form.Group>
                        <Row style={{ padding: "5px" }}>
                          <Col lg={4} md={4} sm={4} xs={4}>
                            <Form.Label>Password</Form.Label>
                          </Col>
                          <Col lg={8} md={8} sm={8} xs={8}>
                            <Form.Control
                              type="password"
                              minLength="6"
                              id="passwordInputRegister"
                              autoComplete="current-password"
                              placeholder="Password"
                              pattern=".*"
                              required
                              style={{ width: "90%" }}
                            ></Form.Control>
                            <Form.Control.Feedback type="invalid">
                              Please enter a valid Password.
                            </Form.Control.Feedback>
                          </Col>
                        </Row>
                      </Form.Group>
                      <Form.Group>
                        <Row style={{ padding: "5px" }}>
                          <Col lg={4} md={4} sm={4} xs={4}>
                            <Form.Label>Confirm Password</Form.Label>
                          </Col>
                          <Col lg={8} md={8} sm={8} xs={8}>
                            <Form.Control
                              type="password"
                              minLength="6"
                              id="password2InputRegister"
                              autoComplete="new-password"
                              placeholder="Confirm Password"
                              pattern=".*"
                              required
                              style={{ width: "90%" }}
                            ></Form.Control>
                            <Form.Control.Feedback type="invalid">
                              Please enter a valid Password.
                            </Form.Control.Feedback>
                          </Col>
                        </Row>
                      </Form.Group>
                      <div
                        className="d-grid gap-2 mt-3"
                        colSpan="2"
                        align="center"
                      >
                        <Button
                          type="submit"
                          className="btn btn-navy mx-auto"
                          name="registerButton"
                          ref={registerButtonRef}
                          value="Register"
                          onClick={() => handleSectionChange("register")}
                          style={{ width: "100%", whiteSpace: "nowrap", backgroundColor: "#4CAF50" }}
                        >
                          Register
                        </Button>
                      </div>
                    </div>
                  </Form>
                </div>
              </Col>
            </Row>
            <Row style={{ height: "20px" }}></Row>
          </div>
        )}
        {isRegistered && (
          <div id="verifyRegistrationSection">
            <div
              className="Auth-form-container   d-flex align-items-center justify-content-center"
              id="verifySection"
            >
              <form
                id="verifyForm"
                onSubmit={handleVerify}
                className="Auth-form"
              >
                <div className="Auth-form-content">
                  <h6 className="Auth-form-title">Verify Registration</h6>
                  <div className="form-group mt-3">
                    <div className="row">
                      <div className="col-md-6">
                        <label>Email Address:</label>
                      </div>
                      <div className="col-md-6">
                        <input
                          type="email"
                          id="emailInputVerify"
                          className="form-control mt-1"
                          placeholder="Email"
                          required
                        />
                        <br />
                        <span
                          id="emailVerifyError"
                          style={{ color: "red" }}
                        ></span>
                      </div>
                    </div>
                  </div>
                  <div className="form-group mt-3">
                    <div className="row">
                      <div className="col-md-6">
                        <label>Verification Code:</label>
                      </div>
                      <div className="col-md-6">
                        <input
                          type="text"
                          id="codeInputVerify"
                          className="form-control mt-1"
                          placeholder="Verification Code"
                          pattern=".*"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="d-grid gap-2 mt-3">
                    <button
                      name="verifyButton"
                      type="submit"
                      className="btn btn-navy mx-auto"
                      ref={verifyButtonRef}
                      value="Verify"
                      style={{ width: "100%", whiteSpace: "nowrap", backgroundColor: "#4CAF50" }}
                    >
                      Verify
                    </button>
                  </div>{" "}
                </div>
              </form>
            </div>
          </div>
        )}
        {isAuthenticated && (
          <Container style={{ width: "100%" }}>
            <Row style={{ height: "10px" }}></Row>
            redirect to the page they came from..
          </Container>
        )}
      </div>
    </>
  );
}

export default LogIn;
